// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getISOWeeksInYear as fn } from "../getISOWeeksInYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getISOWeeksInYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getISOWeeksInYearWithOptions;
